/**
 * @generated SignedSource<<f436e4793e5f5d35389f65020f5b781d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type EditorPrimaryToolbarComponentsGetDraftParentFragment$data = {
  readonly __typename: "Content";
  readonly ancestors: ReadonlyArray<{
    readonly id: string | null | undefined;
  } | null | undefined> | null | undefined;
  readonly id: string | null | undefined;
  readonly " $fragmentType": "EditorPrimaryToolbarComponentsGetDraftParentFragment";
};
export type EditorPrimaryToolbarComponentsGetDraftParentFragment$key = {
  readonly " $data"?: EditorPrimaryToolbarComponentsGetDraftParentFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"EditorPrimaryToolbarComponentsGetDraftParentFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "EditorPrimaryToolbarComponentsGetDraftParentFragment",
  "selections": [
    (v0/*: any*/),
    {
      "concreteType": "Content",
      "kind": "LinkedField",
      "name": "ancestors",
      "plural": true,
      "selections": [
        (v0/*: any*/)
      ]
    },
    {
      "kind": "ScalarField",
      "name": "__typename"
    }
  ],
  "type": "Content"
};
})();

(node as any).hash = "8d1e74aac7d44af0e715791d1017e102";

export default node;
